import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('clientGrid');

    return {
        CONTACT_NAME: t('contactName'),
        EMAIL: t('email'),
        LOADING: t('loading'),
        NAME: t('name'),
        NO_CLIENTS: t('noClients'),
        NO_MORE_CLIENTS: t('noMoreClients'),
        PHONE: t('phone')
    };
};

export default useTranslation;
